module.exports = __webpack_public_path__ + "static/townnews-d25f7bde1f302463a710262033ffd331.png";